import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import qs from "querystring";
import config from "../axios/config";
import createQRCode from "../qrcode-generator/qrcode";
import cookies from "js-cookie";
import { Helmet } from "react-helmet";

class Profile extends Component {
  state = {
    data: { employees: [] },
    name: "",
    email: "",
    token: "",
  };
  componentDidMount() {
    const token = cookies.get("token");
    const newState = this.state;
    newState.token = token;
    this.setState(newState);
    this.fetchData();
  }
  fetchData = () => {
    axios
      .get(`https://koalasurvey.herokuapp.com/company/all`, {
        headers: {
          ...config.header,
          authorization: this.state.token,
        },
      })
      .then((res) => {
        const newState = this.state;
        newState.data = res.data.employees
          ? res.data
          : { employees: [], ...res.data };
        this.setState(newState, this.fetchRating());
      })
      .catch((error) => alert(error.response.data.error));
  };
  handleNameChange = (event) => {
    this.setState({ name: event.target.value });
  };
  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  };
  handleNewEmployee = () => {
    const { name, email } = this.state;
    axios
      .post(
        `https://koalasurvey.herokuapp.com/company/new`,
        qs.stringify({ name, email }),
        {
          headers: {
            ...config.header,
            authorization: this.state.token,
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        this.fetchData();
      })
      .catch((error) => alert(error.response.data.error));
  };
  fetchRating = () => {
    const newState = this.state;
    this.state.data.employees.forEach((emp, index) => {
      axios
        .get(`https://koalasurvey.herokuapp.com/rating/${emp._id}`, {
          headers: {
            ...config.header,
            authorization: this.state.token,
          },
        })
        .then((res) => {
          if (res.data.Messages.length !== 0) {
            newState.data.employees[index] = {
              ...newState.data.employees[index],
              messages: res.data.Messages,
            };
            this.setState(newState);
          }
        })
        .catch((error) => alert(error.response.data.error));
    });
  };
  printIt(qr) {
    var win = window.open();
    win.document.open();
    win.document.write(`
    <body style="
      display: flex;
      justify-content: center;
      align-items: center;
    ">
      ${qr}
    </body>
    `);
    win.document.close();
    win.print();
  }
  handleDelete = (id) => {
    axios
      .delete(`https://koalasurvey.herokuapp.com/company/delete/${id}`, {
        headers: {
          ...config.header,
          authorization: this.state.token,
        },
      })
      .then((res) => this.fetchData())
      .catch((error) => alert(error.response.data.error));
  };
  handleLogout = () => {
    cookies.remove("token");
    cookies.remove("id");
    const newState = this.state;
    newState.token = "";
    this.setState(newState);
    this.fetchData();
    window.location = "/";
  };
  render() {
    const { data } = this.state;
    return this.state.token ? (
      <main className="profile">
        <Helmet>
          <title>{window.location.pathname.split("/", 2)}</title>
        </Helmet>
        <div className="card-main">
          {data.logo ? (
            <img src={data.logo} alt="Logo" />
          ) : (
            <input type="file" className="image custom-file-input" />
          )}
          <div>
            <h1>{data.company ? data.company.name : "Loading"}</h1>
            <h3>ID: {data.company ? data.company._id : "Loading"}</h3>
            <h3>Email: {data.company ? data.company.email : "Loading"}</h3>
            <p>
              Your Company has {data.employees.length} employee. You can add
              more employees down there.
            </p>
          </div>
        </div>
        {data.employees.length !== 0 ? (
          <div className="spacer">
            <div className="line">
              <div></div>
              <div></div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {data.employees.map((emp, index) => (
          <>
            <div
              className={
                index + 1 === data.employees.length ? "row last" : "row"
              }
            >
              <div className="line">
                <div
                  className={
                    index + 1 === data.employees.length ? "deadline" : null
                  }
                ></div>
                <div></div>
              </div>
              <div className="card">
                {emp.image ? (
                  <img src={emp.image} alt="Logo" />
                ) : (
                  <input type="file" className="image custom-file-input" />
                )}
                <div>
                  <h1
                    onClick={() => this.printIt(createQRCode(emp._id))}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    {emp.name}
                    {index === 0 ? (
                      <h3
                        style={{
                          fontFamily: "CairoLighter",
                          paddingLeft: 10,
                          fontSize: 15,
                        }}
                      >
                        (press on the name to get qr code)
                      </h3>
                    ) : (
                      <></>
                    )}
                  </h1>
                  <h3> ID: {emp._id}</h3>
                  <h3> Email: {emp.email}</h3>
                  <p>
                    {emp.messages !== undefined
                      ? `${emp.messages[emp.messages.length - 1].rating}, ${
                          emp.messages[emp.messages.length - 1].message
                        }`
                      : "Last rating will be displayed here"}
                  </p>
                </div>
                <button
                  className="delete"
                  onClick={() => this.handleDelete(emp._id)}
                >
                  DELETE
                </button>
              </div>
            </div>
            {index + 1 !== data.employees.length ? (
              <div className="spacer">
                <div className="line">
                  <div></div>
                  <div></div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </>
        ))}
        <div className="add-form">
          <h1>ADD EMPLOYEES</h1>
          <div>
            <input
              onChange={this.handleNameChange}
              type="text"
              placeholder="Username"
            />
            <input
              onChange={this.handleEmailChange}
              type="email"
              placeholder="Email"
            />
            <button className="primary" onClick={this.handleNewEmployee}>
              ADD EMPLOYEE
            </button>
          </div>
        </div>
        <button className="delete" onClick={this.handleLogout}>
          LOGOUT
        </button>
      </main>
    ) : (
      <main className="profile" style={{ height: "70vh" }}>
        <Helmet>
          <title>{window.location.pathname.split("/", 2)}</title>
        </Helmet>
        PLEASE
        <Link to="/Login" className="primary">
          LOG
        </Link>
        IN FIRST
      </main>
    );
  }
}

export default Profile;
